import { Fragment, useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { mainSelectedTab } from "../../../OfficeTab/atoms";
import { useHistory } from "react-router-dom";
import { SecurityShowState } from "../../Security/atoms/atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { EllipsisHorizontalCircleIcon } from "@heroicons/react/24/outline";
import { useGetOfficeVendorServiceByOfficeId } from "../hooks/useGetOfficeVendorServiceByOfficeId";
import {
  DisableOfficeField,
  officeVendorEditState,
  OfficeVendorModal,
  OfficeVendorSvcOfficeId,
  OfficeVendorSvcViewData,
  rowForEditOfficeSettings,
  selectedRowsStateOfcVendor,
  officeVendorViewFromOffice,
} from "../atoms/atoms";
import { useGetOfcVendorServiceForEdit } from "../hooks/useGetOfcVendorSvcForEdit";
import OfficeVendorServiceView from "./OfficeVendorServiceView";
import OfficeVendorServiceViewAll from "./OfficeVendorServiceViewAll";
import { OfficeVendorServiceModal } from "../modals/OfficeVendorServiceModal";
import { Menu, Transition } from "@headlessui/react";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import useDeactivateOfcVendorSvc from "../hooks/useDeactivateOfficeVendorService";
import { useQueryClient } from "react-query";
import { toast } from "../../../../components/toastNotification";
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/solid";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { OFFICE_PERMISSIONS } from "../permission";

const OfficeVendorSubModule = ({ data }) => {
  const [, setShowOfficeVendorFromOffice] = useRecoilState(
    officeVendorViewFromOffice
  );
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [, setShowState] = useRecoilState(SecurityShowState);
  const [rowViewData, setRowViewData] = useRecoilState(OfficeVendorSvcViewData);
  const [ofcVendorServiceShow, setOfcVendorServiceShow] =
    useRecoilState(OfficeVendorModal);

  const [, setDisableOfficeField] = useRecoilState(DisableOfficeField);
  const [ofcVendorServiceShowAll, setOfcVendorServiceShowAll] = useState(false);
  const history = useHistory();
  const { data: ofcVendorSvcData } = useGetOfficeVendorServiceByOfficeId(
    data.officeId
  );
  const [, setOfficeVendorSvcOfficeId] = useRecoilState(
    OfficeVendorSvcOfficeId
  );
  const setRowToEdit = useSetRecoilState(rowForEditOfficeSettings);

  const [, setOfficeVendorServiceEditState] = useRecoilState(
    officeVendorEditState
  );

  const queryClient = useQueryClient();
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [selectedRowsToDelete, setSelectedRowsToDelete] = useRecoilState(
    selectedRowsStateOfcVendor
  );
  const [, setDisabledButton] = useState(false);

  const userPermissions = useRecoilValue(permissionsSelector);
  const editOfficeVendor = OFFICE_PERMISSIONS.permission_office_vendor_edit;
  const deleteOfficeVendor = OFFICE_PERMISSIONS.permission_office_vendor_delete;

  const {
    mutate: getOfcVendorServiceForEdit,
    isLoading: OfcVendorServiceoading,
  } = useGetOfcVendorServiceForEdit();

  const {
    mutate: BulkDeleteVendor,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeactivateOfcVendorSvc();

  useEffect(() => {
    if (ofcVendorSvcData) {
      if (ofcVendorSvcData.status === 200) {
        toast.fire(
          "Server Error",
          "Cannot retrieve Office Vendor Data",
          "error"
        );
      }
    }
  }, [ofcVendorSvcData]);

  const closeOfficeVendorModal = () => {
    setOfcVendorServiceShow(false);
  };
  const closeOfficeVendorModalAll = () => {
    setOfcVendorServiceShowAll(false);
  };

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire(
        "Success",
        "Office Vendor Services were deactivated successfully",
        "success"
      );
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data?.officeId
      );
      //ssearchRefetch();
    } else if (deacResult.status === 500) {
      if (
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        deacResult.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Office Vendor Services were successfully deactivated, but " +
            deacResult.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Bulk deactivation of Office Vendor Services failed",
          "Server Error: Cannot deactivate Office Vendor Services",
          "error"
        );
      }
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data?.officeId
      );
    } else {
      toast.fire(
        "Bulk deactivation of Office Vendor Services failed",
        "Server Error: Cannot deactivate Office Vendor Services",
        "error"
      );
      queryClient.invalidateQueries(
        "GetOfficeVendorServiceByOfficeId",
        data?.officeId
      );
    }
    resetDeacData();
  }

  const onClickOfficeVendorService = (rowData) => {
    setOfcVendorServiceShow(true);
    setRowViewData(rowData);
    setShowOfficeVendorFromOffice(true);
  };

  // View all Button function
  const onClickViewAll = () => {
    setShowState(false);
    setOfficeVendorSvcOfficeId(data.officeId);
    setOfcVendorServiceShowAll(true);
  };

  const handleEdit = (rowDetails) => {
    getOfcVendorServiceForEdit(rowDetails.recordNumber, {
      onSuccess: (res) => {
        setRowToEdit({
          ...res,
          inactiveAccount: res.inactiveAccount ? "True" : "False",
          vendorCode: rowDetails.vendorCode,
        });
        if (!OfcVendorServiceoading) setOfficeVendorServiceEditState(true);
      },
    });
    setDisableOfficeField(true);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRowsToDelete?.length
    } ${
      selectedRowsToDelete?.length > 1
        ? "Office Vendor Services"
        : "Office Vendor Service"
    } ?`}</div>
  );

  const handleSelectedRowsChange = (rows) => {
    if (rows?.length > 0) {
      const forDelete = rows
        .filter((x) => x.isActive === true)
        .map((row) => row.recordNumber);
      setSelectedRowsToDelete(forDelete);
      setOpenModalDelete(true);
    }
  };

  const handleBulkDelete = () => {
    const data = {
      id: selectedRowsToDelete,
      fromModule: "Office",
    };
    BulkDeleteVendor(data);
    //setSelectedRowsToDelete(ids);
    setOpenModalDelete(false);
    setDisabledButton(false);
  };
  if (ofcVendorSvcData && ofcVendorSvcData.length <= 0) {
    return (
      <div className="flex justify-center text-xs italic col-span-3 p-2">
        No Office Vendor Service
      </div>
    );
  }
  return (
    <>
      {ofcVendorSvcData &&
        ofcVendorSvcData?.length > 0 &&
        ofcVendorSvcData?.map((sec, i) => {
          return (
            i <= 2 && (
              <div key={i} className="">
                <div className="grid grid-cols-1 sm:grid-cols-1">
                  <div className="px-4 py-2 ">
                    <div className="flex justify-between m-1 gap-2">
                      <span className="pr-2">
                        <div
                          className="blueAndBold underline expandedData fontExpand text-xs cursor-pointer"
                          onClick={() => onClickOfficeVendorService(sec)}
                        >
                          {sec.recordNumber
                            ? "MS-" + String(sec.recordNumber).padStart(4, "0")
                            : ""}
                        </div>
                      </span>
                      <Menu as="div" className="items-center flex">
                        <div>
                          <Menu.Button className="">
                            <EllipsisHorizontalCircleIcon
                              className="-mr-2 mt-1 h-5 w-5 text-primary bg-transparent rounded-full hover:bg-primary hover:text-white"
                              aria-hidden="true"
                            />
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 mt-2 w-18 origin-top-right divide-y divide-gray-100 rounded-md bg-white box-shadow ring-1 ring-black ring-opacity-5 focus:outline-none transform opacity-100 scale-100">
                            {userPermissions.includes(editOfficeVendor) && (
                              <div className="px-1 py-1">
                                <Menu.Item>
                                  {({ active }) => (
                                    <button
                                      buttonText="Edit"
                                      className={""}
                                      onClick={() => handleEdit(sec)}
                                      disabled={false}
                                    >
                                      <label className="cursor-pointer fontLabel text-quaternary flex items-center place-content-center hover:text-primary underline   relative  px-2 text-xs font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-quaternary focus:ring-opacity-70">
                                        {" "}
                                        <PencilSquareIcon className="h-4 w-4 " />{" "}
                                        Edit
                                      </label>
                                    </button>
                                  )}
                                </Menu.Item>
                              </div>
                            )}
                            {userPermissions.includes(deleteOfficeVendor) && (
                              <div className="px-1 py-1">
                                <Menu.Item>
                                  {({ active }) => (
                                    <button
                                      buttonText="Deactivate"
                                      className={
                                        sec.isActive
                                          ? "opacity-100"
                                          : "opacity-50"
                                      }
                                      onClick={() =>
                                        handleSelectedRowsChange([sec])
                                      }
                                      disabled={sec.isActive ? false : true}
                                    >
                                      <label className="cursor-pointer fontLabel text-secondary flex items-center place-content-center hover:text-hsecondary underline relative  px-2 text-xs font-medium">
                                        {" "}
                                        <TrashIcon className="h-4 w-4 " />{" "}
                                        Deactivate
                                      </label>
                                    </button>
                                  )}
                                </Menu.Item>
                              </div>
                            )}
                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>

                    <div className="grid lg:grid-cols-4 grid-cols-1">
                      <label className="col-span-2 mx-2 xl:mx-4 expandedLabel fontExpand">
                        Vendor Name:
                      </label>
                      <div
                        className="col-span-2 expandedData blueAndBold underline fontExpand cursor-pointer"
                        onClick={() => {
                          const url = "/officesettings/officesetting";
                          history.push({
                            pathname: "/vendortab/vendor",
                            state: {
                              vendorId: sec.vendorId,
                              officeVendorData: sec,
                              action: "OfficeSettingVendor",
                            },
                          });
                          window.location.reload();
                          let userTabs = [
                            {
                              to: "",
                            },
                          ];
                          [...OfficeTabs].forEach((tabs) => {
                            let temp = [...userPermissions].filter(
                              (user) => user === tabs.permission
                            );
                            if (temp.length > 0)
                              userTabs.push({
                                to: tabs.to,
                              });
                          });
                          userTabs.shift();
                          const index = userTabs.findIndex((c) => c.to === url);
                          setSelectedIndex(index);
                        }}
                      >
                        <span className="pr-2 ">{sec.vendorName}</span>
                      </div>
                    </div>

                    <div className="grid lg:grid-cols-4 grid-cols-1  ">
                      <label className="col-span-2 mx-2 xl:mx-4 expandedLabel fontExpand">
                        Service Provided:
                      </label>
                      <div className="col-span-2 expandedData fontExpand">
                        <span className="pr-2">{sec.servicesProvided}</span>
                      </div>
                    </div>
                    <div className="grid lg:grid-cols-4 grid-cols-1  ">
                      <label className="col-span-2 mx-2 xl:mx-4 expandedLabel fontExpand">
                        Account Number:
                      </label>
                      <div className="col-span-2 expandedData fontExpand">
                        <span className="pr-2">{sec.accountNumber}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          );
        })}
      {ofcVendorSvcData && ofcVendorSvcData.length > 0 && (
        <div className="bg-gray-50 p-2 flex justify-center">
          <button
            onClick={() => onClickViewAll()}
            className="text-primary underline font-semibold "
          >
            View All
          </button>
        </div>
      )}

      {ofcVendorServiceShow && (
        <OfficeVendorServiceModal
          showFullView={ofcVendorServiceShow}
          closeFullView={closeOfficeVendorModal}
          producerCodeId={0}
        >
          <OfficeVendorServiceView data={rowViewData} />
        </OfficeVendorServiceModal>
      )}

      {ofcVendorServiceShowAll && (
        <OfficeVendorServiceModal
          showFullView={ofcVendorServiceShowAll}
          closeFullView={closeOfficeVendorModalAll}
          producerCodeId={0}
        >
          <OfficeVendorServiceViewAll
            data={ofcVendorSvcData?.map((data) => ({
              ...data,
            }))}
          />
        </OfficeVendorServiceModal>
      )}

      {openModalDelete && (
        <ConfirmBoxDelete
          ModalTitle="Deactivate Office Vendor Service"
          qConfirmation={deleteMessage}
          isOpen={openModalDelete}
          onClose={() => setOpenModalDelete(false)}
          onClickFunction={handleBulkDelete}
        />
      )}
    </>
  );
};
export default OfficeVendorSubModule;
